import React, {Fragment} from 'react';
import {UI, Link, Breadcrumbs, Goals, Button, Tree, Layout} from 'components';
import {modal, shorten, useNamedSelector, useParams, useSearchParams} from 'helpers';
import {StartPoint} from '../single/plan/start-point';

export function List() {
  const { redirect } = useSearchParams();
  const { id } = useParams();
  const { goal, milestones = [] } = useNamedSelector('goals.details', { id });
  return (
    <Fragment>
      <Layout.Header justified>
        <Breadcrumbs>
          <Link to="/goals/">Goals</Link>
          <Link to="../">{goal.name}</Link>
          <b>Milestones</b>
        </Breadcrumbs>
        <Button to={redirect || '../'} icon="check" className={['small', 'primary']}>Complete</Button>
      </Layout.Header>
      <UI.List>
        <p>Add all intermediate goals (milestones) that need to be accomplished to achieve the long-term goal.</p>
        <StartPoint {...goal} />
        { milestones.map(milestone =>
          <Goals.Milestones.Card {...milestone} key={milestone.id} />
        ) }
        <p>
          <Button icon="plus" onClick={modal(Goals.Milestones.EditForm, { goal })}>New Milestone</Button>
        </p>
      </UI.List>
    </Fragment>
  );
}
